<script lang="ts">
  // Reusable icon + title + description block for every "nothing here yet" moment in the
  // messaging pane (no conversations, no contacts, nothing selected, empty thread).
  export let icon: string;
  export let title: string | null = null;
  export let description: string;
  export let compact = false;
</script>

<div class="flex h-full flex-col items-center justify-center gap-3 px-6 text-center">
  <div class="flex h-11 w-11 items-center justify-center rounded-full bg-primary/10 text-primary">
    <i class="{icon} text-lg"></i>
  </div>
  <div class="space-y-1">
    {#if title}
      <p class="text-sm font-medium text-foreground">{title}</p>
    {/if}
    <p class="max-w-[220px] text-muted-foreground {compact ? 'text-xs' : 'text-sm'}">{description}</p>
  </div>
  <slot />
</div>
